import { createSlice } from '@reduxjs/toolkit';


const currentTimeSlice = createSlice({
    name: 'current-time',
    initialState: { milliseconds: Date.now() },
    reducers: {
      update: function(state, action) {
        state.milliseconds = action.payload;
      }
    }
});


/**
 * helper function for retrieving the current timestamp from the store
 */
export function getCurrentTime(state) {
  return Math.floor(state.currentTime.milliseconds / 1000);
}

/**
 * Initialise the store, and setup a timer to periodically update the current
 * time
 */
export function initialise(dispatch) {
  if (window && window.setInterval) {
    window.setInterval(function() {
      dispatch(currentTimeSlice.actions.update(Date.now()));
    }, 30000);
  }
}


export default currentTimeSlice.reducer;

